import { createLexicalCTAEditor } from 'modules/Lexical/editors';
import { $verifyStyleForFont } from 'modules/Lexical/Plugins/FontBrandStylePlugin/brandStyle';
import * as Models from 'models';

type Props = {
  callToActionComponent: Models.CallToAction;
  colors: Models.BrandColorsList;
  fonts: Models.BrandFontsList;
};
export const applyProjectFontStyleToCTAComponent = ({ callToActionComponent, colors, fonts }: Props): Models.CallToAction => {
  const { lexicalState } = callToActionComponent;
  if (!lexicalState) {
    return callToActionComponent;
  }
  const editor = createLexicalCTAEditor(lexicalState);

  editor.update(() => {
    $verifyStyleForFont(colors, fonts);
  }, { discrete: true });

  return { ...callToActionComponent, lexicalState: JSON.stringify(editor.getEditorState()) };
};
